<template lang="pug">
button.image-button(
  :style="dynamicBackground"
  @click="$emit('click', action)"
  )
</template>

<script>
export default {
  name: 'IntegrationImageButton',
  props: {
    action: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      buttonPressed: false,
      buttonOver: false,
    }
  },
  computed: {
    dynamicBackground() {
      return {
        '--normalImage': `url('${this.imageData(
          this.action.ImageMimeType,
          this.action.ImageNormal,
        )}')`,
        '--focusImage': `url('${this.imageData(
          this.action.ImageMimeType,
          this.action.ImageFocus,
        )}')`,
        '--pressedImage': `url('${this.imageData(
          this.action.ImageMimeType,
          this.action.ImagePressed,
        )}')`,
        '--buttonWidth': `${this.action.ButtonWidth}px`,
        '--buttonHeight': `${this.action.ButtonHeight}px`,
      }
    },
  },
  methods: {
    imageData(mimeType, type) {
      return `data:${mimeType};base64,${type}`
    },
  },
}
</script>

<style scoped lang="stylus">
.image-button
  width var(--buttonWidth)
  height var(--buttonHeight)
  background-repeat no-repeat
  background-image var(--normalImage)

  &:hover
    background-image var(--focusImage)

  &:focus
    background-image var(--focusImage)
    outline none

  &:active
    background-image var(--pressedImage)
</style>
